import { masterFunction } from "../api/api";

const getError = (err) => {
  let response = err && err.response ? err.response : null;
  if (!response) return;

  // Decrypt / normalize the error payload the same way as success responses
  let data = masterFunction(response, ".data");
  console.log(data);

  if (data && data.error) {
    if (typeof data.error === "string") {
      return data.error;
    }
    let firstError = data.error[Object.keys(data.error)[0]];
    return firstError?.msg;
  } else if (data?.message) {
    return data.message;
  }
};
export default getError;
